import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import readConfig from './utils/readClientConfiguration';
import appConfiguration from './config/default.json'; // opcjonalne, do ładowania tłumaczeń z backendu

let countryCode = readConfig(appConfiguration, 'countrySymbol') || 'hr';
// W trybie deweloperskim upewnij się, że używamy dostępnych tłumaczeń
if (process.env.NODE_ENV === 'development') {
  console.log('Using HR translations in development mode');
  countryCode = 'hr';
}
i18n
    .use(HttpBackend) // umożliwia ładowanie tłumaczeń z plików JSON
    .use(initReactI18next) // integracja z Reactem
    .init({
        lng: countryCode,
        debug: true, // włącz debugowanie w trakcie developmentu
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: '/i18n/{{lng}}/translations.json', // ścieżka do plików tłumaczeń
        },
    });

export default i18n;